const resolveTenantBaseDomain = () => {
  if (process.env.REACT_APP_TENANT_BASE_DOMAIN) {
    return process.env.REACT_APP_TENANT_BASE_DOMAIN;
  }
  if (typeof window === "undefined") {
    return "dev.routeeye.io";
  }
  const host = window.location.hostname || "";
  if (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "dev.routeeye.io" ||
    host.endsWith(".dev.routeeye.io")
  ) {
    return "dev.routeeye.io";
  }
  return "routeeye.io";
};

const config = {
  baseURL: process.env.REACT_APP_BASE_URL || "https://dev-api.routeeye.io/api",
  authBaseURL: process.env.REACT_APP_AUTH_BASE_URL || "https://da.routeeye.io",
  notificationServiceURL:
    process.env.REACT_APP_NOTIFICATION_SERVICE_URL || "https://notification-api.kalrav.ai",
  firebaseVapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "BNqrAMsqGvDoNDm9BHr06DiWKYKIcruAWrLZMCHsttJ0P_r3OJUSr-nVaLtKnFSnYRz7zFK-dGbYLEIUpd9kwj0",
  isDemo: process.env.REACT_APP_IS_DEMO === 'true' || false,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyD7rqUpTzUpEbxm-Xc7ikltFJGzOhd92Qk",
  tenantBaseDomain: resolveTenantBaseDomain(),
  pages: {
    login_page: {
      header: process.env.REACT_APP_LOGIN_HEADER || "Login Here"
    }
  },
  hubHosts: process.env.REACT_APP_HUB_HOSTS || "dev.routeeye.io,app.routeeye.io,www.routeeye.io,routeeye.io",
};




export default config; 